import type { ReactNode } from "react";
import { AuthProvider as SharedAuthProvider } from "@comai-portal/auth-ui";
import { authClient } from "../services/api";

/**
 * CO 048 Phase 1 — portal's AuthProvider is now a thin shim over the shared
 * `@comai-portal/auth-ui` provider. It supplies portal's bound auth client
 * (created in services/api.ts against VITE_API_BASE_URL) and portal's logout
 * redirect ("/"). The canonical provider owns the manager state, token plumbing,
 * and the email/password + Google login/register methods — the deduplicated
 * surface this CO exists to share.
 *
 * Same export name and signature as before, so App.tsx and every consumer of
 * `contexts/AuthContext` are unchanged.
 */
export const AuthProvider = ({ children }: { children: ReactNode }) => (
  <SharedAuthProvider client={authClient} logoutRedirect="/">
    {children}
  </SharedAuthProvider>
);
